/* ----- Quick Add popup -----
   Click → fetch /products/{handle}.js → render variant pickers in a modal →
   user picks options → POST /cart/add.js → refresh cart drawer + show success.
   Shared across all sections that render the valor-quick-add-modal snippet
   (valor-products, valor-collection, and the Configure-Build upsell card).
*/

/* ----- Shared cart-drawer refresher -----
   Several places (quick add modal, upsell "Add to Build" buttons, future
   custom add-to-cart UIs) need to tell Impulse's CartDrawer that the cart
   changed. Empirically `ajaxProduct:added` alone sometimes leaves the drawer
   contents stale on inner pages (the drawer opens but the items list/subtotal
   don't refresh), so this helper fires the full set of documented Impulse
   hooks AND falls back to a direct buildCart() call if a CartDrawer instance
   is exposed.

   Public API:
     window.refreshValorCartDrawer({ product: <data from /cart/add.js> })
     window.refreshValorCartDrawer()               // no product detail needed
*/
window.refreshValorCartDrawer = function (detail) {
  detail = detail || {};
  /* 1. Impulse's CartDrawer.init() listens for this — calls buildCart()+open() */
  document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: detail }));
  /* 2. Impulse's CartForm.init() listens for this — calls buildCart() directly.
        Belt-and-braces in case the CartDrawer instance was destroyed / replaced. */
  document.dispatchEvent(new CustomEvent('cart:build'));
  /* 3. Impulse's CartDrawer.init() listens for this — opens the drawer. */
  document.dispatchEvent(new CustomEvent('cart:open'));
  /* 4. Generic — for any third-party listeners. */
  document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
};

(function () {
  function moneyFormat(cents) {
    if (cents == null) return '';
    var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    try {
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    } catch (e) { return '$' + amount; }
  }

  function findVariant(product, selected) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var j = 0; j < product.options.length; j++) {
        if (v.options[j] !== selected[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  /* product.options in /products/{handle}.js is sometimes
     ["Size", "Color"]            (strings)
     and sometimes
     [{"name":"Size","values":[...]}, ...]   (objects).
     Normalize. */
  function optName(opt) {
    if (typeof opt === 'string') return opt;
    return (opt && opt.name) || '';
  }
  function optValues(opt, optIdx, product) {
    if (opt && opt.values && opt.values.length) return opt.values;
    var seen = {}, out = [];
    product.variants.forEach(function (v) {
      var val = v.options[optIdx];
      if (val != null && !seen[val]) { seen[val] = true; out.push(val); }
    });
    return out;
  }

  function isColorOption(name) {
    return /color|colour/i.test(String(name || ''));
  }

  var COLOR_HEX = {
    'charcoal':'#1A2535','coyote':'#8B7355','coyote tan':'#8B7355','tan':'#8B7355',
    'olive':'#4A5E3A','od':'#4A5E3A','od green':'#4A5E3A','olive drab':'#4A5E3A',
    'black':'#111111','white':'#FFFFFF','red':'#B53A2C','patriot red':'#B53A2C',
    'navy':'#1E3A5F','thin blue line':'#1E3A5F','orange':'#D9651F','safety orange':'#D9651F',
    'pink':'#D8859A','rose':'#D8859A','purple':'#6E4F8F'
  };

  function colorHex(value) {
    var key = String(value || '').toLowerCase().trim();
    return COLOR_HEX[key] || '#888888';
  }

  /* ----- Modal controller (one section may host multiple sections; each
     has its own modal element in the DOM). We bind once per modal. ----- */
  document.querySelectorAll('[data-vw-qa-modal]').forEach(function (modal) {
    if (modal.__vwBound) return;
    modal.__vwBound = true;

    var titleEl = modal.querySelector('[data-vw-qa-title]');
    var priceEl = modal.querySelector('[data-vw-qa-price]');
    var compareEl = modal.querySelector('[data-vw-qa-compare]');
    var imageEl = modal.querySelector('[data-vw-qa-image]');
    var thumbsEl = modal.querySelector('[data-vw-qa-thumbs]');
    var optionsEl = modal.querySelector('[data-vw-qa-options]');
    var mfEl = modal.querySelector('[data-vw-qa-mf]');
    var subtitleEl = modal.querySelector('[data-vw-qa-subtitle]');
    var shortdescEl = modal.querySelector('[data-vw-qa-shortdesc]');
    var formEl = modal.querySelector('[data-vw-qa-form]');
    var submitEl = modal.querySelector('[data-vw-qa-submit]');
    var viewEl = modal.querySelector('[data-vw-qa-view-full]');
    var errorEl = modal.querySelector('[data-vw-qa-error]');
    var successEl = modal.querySelector('[data-vw-qa-success]');

    var state = { product: null, selected: [], current: null, suppressVariantImage: false };
    var cache = {};
    /* Per-handle cache of the metafield fields' HTML, cloned from the PDP. */
    var mfCache = {};
    /* Per-handle cache of the sub_title + short_description text blocks (HTML). */
    var textCache = {};
    /* Per-handle cache of the size-guide image URL (from the PDP's custom.size_guide_image). */
    var sizeGuideCache = {};
    /* Per-handle cache of the Control Handle add-on variant id (from the PDP). */
    var controlHandleAddonCache = {};

    /* Show/hide the modal's "Size Guide" link and point it at the product's image. */
    function applySizeGuide(url) {
      var el = modal.querySelector('[data-vw-qa-size-guide]');
      if (!el) return;
      if (url) { el.setAttribute('data-size-guide-src', url); el.hidden = false; }
      else { el.removeAttribute('data-size-guide-src'); el.hidden = true; }
    }

    function injectText(t) {
      t = t || { subtitle: '', desc: '' };
      if (subtitleEl) { subtitleEl.innerHTML = t.subtitle || ''; subtitleEl.hidden = !(t.subtitle || '').trim(); }
      if (shortdescEl) { shortdescEl.innerHTML = t.desc || ''; shortdescEl.hidden = !(t.desc || '').trim(); }
    }
    /* Per-handle map of color-value name → swatch inline style, read from the
       PDP's rendered swatches (which use the theme Color map). Lets the modal show
       the SAME colors instead of its limited built-in hex list. */
    var swatchCache = {};

    /* Apply the PDP swatch colors/images to the modal's color value buttons. */
    function applySwatchStyles(map) {
      if (!map || !optionsEl) return;
      optionsEl.querySelectorAll('.vw-qa-value--color').forEach(function (btn) {
        var v = (btn.getAttribute('data-vw-qa-val') || '').toLowerCase().trim();
        if (map[v]) {
          /* Clear the built-in fallback bg, then apply the PDP swatch style. */
          btn.style.backgroundColor = '';
          btn.style.cssText += ';' + map[v];
        }
      });
    }

    /* Mirror the PDP rule: a "color"-named option renders as SWATCHES only when
       its values have a real swatch/color-map entry. Options like "Hardware
       Color" (values "Stainless Steel", …) have none → render as TEXT buttons.
       Runs once the PDP swatch map is known. */
    function refineColorOptions() {
      if (!optionsEl) return;
      var map = (state.product && swatchCache[state.product.handle]) || {};
      optionsEl.querySelectorAll('.vw-qa-option').forEach(function (wrap) {
        var colorBtns = wrap.querySelectorAll('.vw-qa-value--color');
        if (!colorBtns.length) return;
        var hasSwatch = false;
        colorBtns.forEach(function (b) {
          var v = (b.getAttribute('data-vw-qa-val') || '').toLowerCase().trim();
          if (map[v]) hasSwatch = true;
        });
        if (hasSwatch) return; /* genuine color option → keep swatches */
        colorBtns.forEach(function (b) {
          b.classList.remove('vw-qa-value--color');
          b.style.cssText = b.style.cssText.replace(/background[^;]*;?/gi, '');
          b.textContent = b.getAttribute('data-vw-qa-val') || '';
          b.removeAttribute('title');
          b.removeAttribute('aria-label');
        });
      });
    }

    /* Fetch the product page once and clone its metafield option/textarea fields
       (valor-mf-option / valor-mf-textarea + Velcro) so the quick view matches the
       product section exactly. /products/{handle}.js has no metafields, so we read
       the rendered HTML. Variant options (data-vp-option-idx) are skipped — those
       are handled by the variant picker built from the .js payload. */
    function injectMetafields(html) {
      if (!mfEl) return;
      mfEl.innerHTML = html || '';
      mfEl.querySelectorAll('[data-vp-mf-ta]').forEach(function (ta) {
        var max = ta.getAttribute('maxlength') || '';
        var field = ta.closest('.vp-field');
        var counter = field ? field.querySelector('[data-vp-mf-ta-counter]') : null;
        if (counter) counter.textContent = ta.value.length + ' / ' + max;
      });
      applyDependentFields(); /* gate dependent fields once cloned into the modal */
      wireUpsellOptions();    /* make the cloned upsell add-on's option swatches/selects work */
    }

    /* Wire the cloned upsell add-on option selectors (swatches/selects) so changing them
       updates the add-on's variant id + price + selected-value labels — mirrors the PDP. */
    function wireUpsellOptions() {
      if (!mfEl) return;
      mfEl.querySelectorAll('[data-vp-upsell-block]').forEach(function (blk) {
        var optsWrap = blk.querySelector('[data-vp-upsell-options]');
        if (!optsWrap) return;
        var dataEl = optsWrap.querySelector('[data-vp-upsell-variants]');
        var checkbox = blk.querySelector('[data-vp-upsell-addon]');
        var priceEl = blk.querySelector('[data-vp-upsell-price]');
        var variants;
        try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
        function chosen() {
          return Array.prototype.map.call(optsWrap.querySelectorAll('[data-vp-upsell-optidx]'), function (opt) {
            var sel = opt.querySelector('select');
            if (sel) return sel.value;
            var active = opt.querySelector('.vp-upsell-swatch.is-active');
            return active ? active.getAttribute('data-value') : '';
          });
        }
        function syncAddon() {
          var sel = chosen();
          Array.prototype.forEach.call(optsWrap.querySelectorAll('[data-vp-upsell-optidx]'), function (opt, i) {
            var vEl = opt.querySelector('[data-vp-upsell-optvalue]');
            if (vEl) vEl.textContent = sel[i] || '';
          });
          var match = null;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            if (v.options.length === sel.length && v.options.every(function (o, idx) { return o === sel[idx]; })) { match = v; break; }
          }
          if (!match || !checkbox) return;
          checkbox.setAttribute('data-vp-upsell-addon', match.id);
          if (priceEl) priceEl.textContent = '+' + moneyFormat(match.price);
          if (!match.available) { checkbox.checked = false; checkbox.disabled = true; }
          else { checkbox.disabled = false; }
        }
        optsWrap.addEventListener('change', syncAddon);
        optsWrap.addEventListener('click', function (e) {
          var sw = e.target.closest('.vp-upsell-swatch');
          if (!sw) return;
          var group = sw.parentNode;
          group.querySelectorAll('.vp-upsell-swatch').forEach(function (b) { b.classList.toggle('is-active', b === sw); });
          syncAddon();
        });
        syncAddon();
      });
    }
    function loadMetafields(handle) {
      if (mfCache[handle] !== undefined) {
        injectMetafields(mfCache[handle]);
        applySwatchStyles(swatchCache[handle]);
        refineColorOptions();
        injectText(textCache[handle]);
        applySizeGuide(sizeGuideCache[handle]);
        return;
      }
      fetch('/products/' + handle)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var box = document.createElement('div');
          /* Sub title + short description (PDP Text blocks). First text block →
             subtitle (eyebrow under the title); the rest → short description. */
          var textBlocks = doc.querySelectorAll('.vp-info .vp-block-text');
          var txt = { subtitle: '', desc: '' };
          textBlocks.forEach(function (tb, i) {
            var isSub = i === 0 || /sub|eyebrow/i.test(tb.className);
            if (isSub && !txt.subtitle) { txt.subtitle = tb.innerHTML; }
            else { txt.desc += tb.innerHTML; }
          });
          textCache[handle] = txt;
          /* Read the PDP's rendered color swatches (name → inline style) so the
             modal shows the same colors as the theme Color map. */
          var sw = {};
          doc.querySelectorAll('[data-vp-option-btn][data-value]').forEach(function (b) {
            var v = (b.getAttribute('data-value') || '').toLowerCase().trim();
            var st = b.getAttribute('style') || '';
            if (v && st && /background/i.test(st)) sw[v] = st;
          });
          swatchCache[handle] = sw;
          /* Clone, in document order: metafield option/textarea fields, the upsell
             add-on checkbox, and the measure-confirm checkbox. Skip the real variant
             option fields (handled by the modal's own variant picker). */
          doc.querySelectorAll('.vp-field, .vp-upsell-wrap, .vp-checkbox').forEach(function (f) {
            if (f.classList.contains('vp-field')) {
              if (f.hasAttribute('data-vp-option-idx')) return;               /* real variant option */
              if (!f.querySelector('[data-vp-mf-btn], [data-vp-mf-ta]')) return; /* not a metafield field */
            }
            var clone = f.cloneNode(true);
            /* Drop ids/for so cloned fields can't collide with the PDP's own ids. */
            clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
            clone.querySelectorAll('label[for]').forEach(function (el) { el.removeAttribute('for'); });
            box.appendChild(clone);
          });
          mfCache[handle] = box.innerHTML;
          /* Size guide image URL — from the PDP section root data attribute. */
          var sgEl = doc.querySelector('[data-vp-size-guide-url]');
          var sgUrl = sgEl ? (sgEl.getAttribute('data-vp-size-guide-url') || '').trim() : '';
          sizeGuideCache[handle] = sgUrl;
          /* Control Handle add-on variant id — from the PDP section root. */
          var chSecEl = doc.querySelector('[data-vp-control-handle-addon]');
          controlHandleAddonCache[handle] = chSecEl ? (chSecEl.getAttribute('data-vp-control-handle-addon') || '').trim() : '';
          injectMetafields(mfCache[handle]);
          applySwatchStyles(sw);
          refineColorOptions();
          injectText(txt);
          applySizeGuide(sgUrl);
        })
        .catch(function () { mfCache[handle] = ''; injectMetafields(''); applySizeGuide(''); });
    }

    /* Wire the cloned metafield fields (bound once per modal, on the FORM so it
       keeps working even when a dependent field is moved next to its trigger
       option in the options container): pill groups update their value label +
       hidden input; textareas update the character counter. Mirrors the PDP. */
    if (formEl) {
      formEl.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-vp-mf-btn]');
        if (!pill || !formEl.contains(pill)) return;
        var key = pill.getAttribute('data-vp-mf-btn');
        var val = pill.getAttribute('data-value');
        var field = pill.closest('.vp-field') || formEl; /* scope to this field */
        field.querySelectorAll('[data-vp-mf-btn="' + key + '"]').forEach(function (x) {
          x.classList.toggle('is-active', x === pill);
        });
        var lbl = field.querySelector('[data-vp-mf-value="' + key + '"]');
        if (lbl) lbl.textContent = val;
        var input = field.querySelector('[data-vp-mf-input="' + key + '"]');
        if (input) input.value = val;
        applyDependentFields(); /* a metafield option may itself be a trigger */
      });
      formEl.addEventListener('input', function (e) {
        var ta = e.target.closest('[data-vp-mf-ta]');
        if (ta) {
          var max = ta.getAttribute('maxlength') || '';
          var field = ta.closest('.vp-field');
          var counter = field ? field.querySelector('[data-vp-mf-ta-counter]') : null;
          if (counter) counter.textContent = ta.value.length + ' / ' + max;
          return;
        }
        /* Upsell add-on free-text field (e.g. name tape text) counter. */
        var up = e.target.closest('[data-vp-upsell-text]');
        if (up) {
          var upMax = up.getAttribute('maxlength') || '';
          var upCounter = up.parentNode.querySelector('[data-vp-upsell-text-counter]');
          if (upCounter) upCounter.textContent = up.value.length + ' / ' + upMax;
        }
      });
    }

    function setError(msg) {
      if (!errorEl) return;
      if (msg) { errorEl.textContent = msg; errorEl.hidden = false; }
      else { errorEl.hidden = true; }
    }
    function setSuccess(msg) {
      if (!successEl) return;
      if (msg) { successEl.textContent = msg; successEl.hidden = false; }
      else { successEl.hidden = true; }
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      state.product = null;
    }
    function open() {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setError(''); setSuccess('');
    }

    modal.querySelectorAll('[data-vw-qa-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.hidden && e.key === 'Escape') close();
    });

    function renderProduct(product) {
      state.product = product;
      /* Locate a "color chart" reference image (media whose alt says "color chart")
         so clicking a colour swatch can show it — mirrors the PDP behaviour. */
      state.colorChartSrc = '';
      if (product.media && product.media.length) {
        for (var ci = 0; ci < product.media.length; ci++) {
          var calt = (product.media[ci].alt || '').toLowerCase();
          if (calt.indexOf('color chart') !== -1 || calt.indexOf('colour chart') !== -1) {
            state.colorChartSrc = (product.media[ci].preview_image && product.media[ci].preview_image.src) || '';
            break;
          }
        }
      }
      state.selected = product.options.map(function (_, i) {
        var v = product.selected_or_first_available_variant || product.variants.find(function (x) { return x.available; }) || product.variants[0];
        return (v && v.options[i]) || product.options.map(function () { return ''; })[i];
      });

      titleEl.textContent = product.title;
      imageEl.src = (product.featured_image || (product.images && product.images[0]) || '');
      imageEl.alt = product.title;
      viewEl.href = '/products/' + product.handle;

      /* "Add-on only" products (Personalization Fee, Control Handle) can't be bought
         on their own: drop the Add-to-Cart button and the "View full details" link in
         the popup (their product page redirects home anyway). */
      var addonHandles = modal.getAttribute('data-vw-qa-addon-handles') || '';
      state.isAddonProduct = addonHandles.indexOf(',' + product.handle + ',') !== -1;
      if (submitEl) submitEl.style.display = state.isAddonProduct ? 'none' : '';
      if (viewEl) viewEl.style.display = state.isAddonProduct ? 'none' : '';

      renderThumbs(product);

      /* Keep the featured image on open; only swap to a variant image once the
         shopper actively changes an option (avoids the variant-image flash). */
      state.suppressVariantImage = true;
      renderOptions();
      loadMetafields(product.handle);
      updateVariant();
    }

    /* Build the thumbnail strip from the product's media/images. Clicking a
       thumb swaps the main image (and stops variant changes from overriding it
       until the shopper changes an option again). */
    function renderThumbs(product) {
      if (!thumbsEl) return;
      thumbsEl.innerHTML = '';
      var srcs = [];
      if (product.media && product.media.length) {
        product.media.forEach(function (m) {
          if (m.preview_image && m.preview_image.src) srcs.push(m.preview_image.src);
        });
      }
      if (!srcs.length && product.images && product.images.length) {
        srcs = product.images.slice();
      }
      if (srcs.length < 2) { thumbsEl.hidden = true; return; } /* nothing to switch between */
      thumbsEl.hidden = false;
      var activeSrc = imageEl.src;
      srcs.forEach(function (src) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vw-qa-thumb';
        b.setAttribute('data-vw-qa-thumb-src', src);
        if (activeSrc && src.split('?')[0] === activeSrc.split('?')[0]) b.classList.add('is-active');
        var im = document.createElement('img');
        im.src = src; im.alt = ''; im.loading = 'lazy';
        b.appendChild(im);
        thumbsEl.appendChild(b);
      });
    }

    if (thumbsEl) {
      thumbsEl.addEventListener('click', function (e) {
        var b = e.target.closest('.vw-qa-thumb');
        if (!b) return;
        var src = b.getAttribute('data-vw-qa-thumb-src');
        if (!src) return;
        imageEl.src = src;
        state.suppressVariantImage = true; /* keep this image until an option changes */
        thumbsEl.querySelectorAll('.vw-qa-thumb').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    }

    /* Colour swatch (JS-built variant .vw-qa-value--color OR cloned metafield .vp-swatch)
       → show the product's colour-chart image if it has one (media alt "color chart").
       Runs after the variant handler (0ms timeout) so the chart wins, and suppresses the
       variant-image swap so it stays until another option is changed. Non-colour options
       don't match these selectors, so they keep the default variant image. */
    modal.addEventListener('click', function (e) {
      var sw = e.target.closest('.vw-qa-value--color, .vp-swatch');
      if (!sw || !modal.contains(sw) || !state.colorChartSrc) return;
      setTimeout(function () {
        imageEl.src = state.colorChartSrc;
        state.suppressVariantImage = true;
        if (thumbsEl) {
          var chartKey = state.colorChartSrc.split('?')[0];
          thumbsEl.querySelectorAll('.vw-qa-thumb').forEach(function (x) {
            var xs = (x.getAttribute('data-vw-qa-thumb-src') || '').split('?')[0];
            x.classList.toggle('is-active', xs === chartKey);
          });
        }
      }, 0);
    });

    function renderOptions() {
      var p = state.product;
      optionsEl.innerHTML = '';
      /* Hide the auto "Title / Default Title" option on products with no real variants */
      if (p.variants && p.variants.length === 1 && p.variants[0].title === 'Default Title') {
        return;
      }
      p.options.forEach(function (opt, optIdx) {
        var name = optName(opt);
        var values = optValues(opt, optIdx, p);

        var wrap = document.createElement('div');
        wrap.className = 'vw-qa-option';
        wrap.setAttribute('data-vw-qa-optname', name);
        var label = document.createElement('span');
        label.className = 'vw-qa-option__name';
        /* Use the SAME option name as the product page (no "Color" rename). */
        label.innerHTML = name + ': <strong data-vw-qa-current="' + optIdx + '"></strong>';
        wrap.appendChild(label);

        var list = document.createElement('div');
        list.className = 'vw-qa-option__values';
        values.forEach(function (val) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'vw-qa-value';
          btn.setAttribute('data-vw-qa-opt', String(optIdx));
          btn.setAttribute('data-vw-qa-val', val);
          if (isColorOption(name)) {
            btn.classList.add('vw-qa-value--color');
            btn.style.backgroundColor = colorHex(val);
            btn.setAttribute('aria-label', val);
            btn.title = val;
          } else {
            btn.textContent = val;
          }
          list.appendChild(btn);
        });
        wrap.appendChild(list);
        optionsEl.appendChild(wrap);
      });

      optionsEl.querySelectorAll('.vw-qa-value').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-vw-qa-opt'), 10);
          var val = btn.getAttribute('data-vw-qa-val');
          state.selected[idx] = val;
          if (btn.classList.contains('vw-qa-value--color') && state.colorChartSrc) {
            /* Colour option + product has a colour chart → suppress the variant-image
               swap and show the chart directly, so the variant image never flashes. */
            state.suppressVariantImage = true;
            updateVariant();
            imageEl.src = state.colorChartSrc;
          } else {
            state.suppressVariantImage = false; /* non-colour → default variant image */
            updateVariant();
          }
        });
      });
    }

    function updateVariant() {
      var p = state.product;
      var current = findVariant(p, state.selected);
      state.current = current;

      /* highlight active values + flag unavailable combos */
      p.options.forEach(function (_, optIdx) {
        var label = optionsEl.querySelector('[data-vw-qa-current="' + optIdx + '"]');
        if (label) label.textContent = state.selected[optIdx] || '';
        optionsEl.querySelectorAll('.vw-qa-value[data-vw-qa-opt="' + optIdx + '"]').forEach(function (btn) {
          var val = btn.getAttribute('data-vw-qa-val');
          btn.classList.toggle('is-active', val === state.selected[optIdx]);
          /* Test availability with the candidate value substituted for this option */
          var test = state.selected.slice();
          test[optIdx] = val;
          var match = findVariant(p, test);
          btn.classList.toggle('is-unavailable', !match || !match.available);
          btn.disabled = !match;
        });
      });

      if (!state.suppressVariantImage && current && current.featured_image && current.featured_image.src) {
        imageEl.src = current.featured_image.src;
      }
      if (current) {
        priceEl.textContent = moneyFormat(current.price);
        if (current.compare_at_price && current.compare_at_price > current.price) {
          compareEl.textContent = moneyFormat(current.compare_at_price);
        } else {
          compareEl.textContent = '';
        }
        submitEl.disabled = !current.available;
        submitEl.textContent = current.available ? 'Add to Cart' : 'Sold Out';
      } else {
        submitEl.disabled = true;
        submitEl.textContent = 'Unavailable';
        priceEl.textContent = '';
        compareEl.textContent = '';
      }

      applyDependentFields(); /* show/hide fields gated on a Yes/No option */
    }

    /* ----- Conditional dependent metafield fields -----
       Mirror the PDP gate: a cloned metafield field (in mfEl) is shown ONLY when
       its trigger option is set to a "Yes" value; otherwise it's hidden and its
       input disabled so it is NOT sent to the cart. The trigger option may be a
       variant option (optionsEl / state.selected) or a metafield pill (mfEl). */
    var DEPENDENT_FIELDS = [
      { fieldSel: '[data-vp-mf-block="ejector_color"]', inputSel: '[data-vp-mf-input="ejector_color"]', triggerRe: /quick release ejector|quick release webbing|qr ejector|qr webbing/i, clearOnHide: false },
      { fieldSel: '[data-vp-mf-textarea="what_would_you_like_personalized_on_your_leash_14"]', inputSel: '[data-vp-mf-ta]', triggerRe: /personaliz/i, clearOnHide: true }
    ];

    /* All trigger controls matching a name regex, each with its DOM element and a
       value getter. Covers BOTH a variant option (optionsEl) AND a metafield pill
       block (formEl), so a dependent field can respond to either. */
    function triggersByName(re) {
      var list = [];
      if (optionsEl) {
        optionsEl.querySelectorAll('.vw-qa-option').forEach(function (o) {
          var nm = o.querySelector('.vw-qa-option__name');
          if (nm && re.test(nm.textContent)) {
            list.push({ el: o, value: function () {
              var cur = o.querySelector('[data-vw-qa-current]');
              return cur ? (cur.textContent || '').trim() : '';
            } });
          }
        });
      }
      formEl.querySelectorAll('[data-vp-mf-block]').forEach(function (bl) {
        var lbl = bl.querySelector('.vp-field-label span');
        if (lbl && re.test(lbl.textContent)) {
          list.push({ el: bl, value: function () {
            var active = bl.querySelector('[data-vp-mf-btn].is-active[data-value]');
            if (active) return active.getAttribute('data-value') || '';
            var inp = bl.querySelector('[data-vp-mf-input]');
            return inp ? (inp.value || '') : '';
          } });
        }
      });
      return list;
    }

    function applyDependentFields() {
      if (!formEl) return;
      DEPENDENT_FIELDS.forEach(function (g) {
        var field = formEl.querySelector(g.fieldSel);
        if (!field) return;

        /* The first trigger set to "Yes" wins — move the field under it. */
        var trigs = triggersByName(g.triggerRe);
        var yesTrig = null;
        for (var k = 0; k < trigs.length; k++) {
          if (/yes/i.test(trigs[k].value())) { yesTrig = trigs[k]; break; }
        }
        var show = !!yesTrig;
        if (show && yesTrig.el.parentNode && yesTrig.el.nextSibling !== field) {
          yesTrig.el.parentNode.insertBefore(field, yesTrig.el.nextSibling);
        }
        field.style.display = show ? '' : 'none';
        field.hidden = !show;
        var input = g.inputSel ? field.querySelector(g.inputSel) : null;
        if (input) {
          input.disabled = !show;             /* disabled inputs are skipped on add */
          if (!show && g.clearOnHide) input.value = '';
        }
      });
    }

    /* Disable native HTML5 validation. Required controls like the measure-confirm
       checkbox are display:none, so the browser can't focus them to show its bubble
       and silently blocks the submit event — which would stop our manual validation
       (and the vp-invalid cue) from ever running. Mirrors the PDP. */
    formEl.setAttribute('novalidate', 'novalidate');
    formEl.noValidate = true;

    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!state.current || !state.current.available) return;
      if (state.isAddonProduct) return; /* add-on only product — not purchasable here */
      setError(''); setSuccess('');

      /* Validate required fields (text/textarea must be filled; required
         checkboxes like the measure-confirm must be ticked). Search the whole
         form so moved dependent fields are still covered. Flags the field's
         wrapper with `vp-invalid` (red outline) exactly like the PDP does. */
      var reqEls = formEl.querySelectorAll('[required]');
      for (var r = 0; r < reqEls.length; r++) {
        var rq = reqEls[r];
        if (rq.disabled) continue; /* hidden/disabled dependent field — skip */
        var invalid = (rq.type === 'checkbox' || rq.type === 'radio') ? !rq.checked : !(rq.value || '').trim();
        if (invalid) {
          var wrap = rq.closest('.vp-checkbox, .vp-field, .vp-questions, .vp-upsell') || rq;
          wrap.classList.add('vp-invalid');
          wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (rq.type !== 'checkbox' && rq.type !== 'radio' && rq.offsetParent !== null) {
            try { rq.focus({ preventScroll: true }); } catch (err) {}
          }
          setError('Please complete the required fields.');
          return;
        }
      }

      /* Collect line item properties (skip disabled + unchecked checkboxes/radios). */
      var properties = {};
      formEl.querySelectorAll('[name^="properties["]').forEach(function (el) {
        if (el.disabled) return; /* hidden dependent field (e.g. Ejector Color on "No") */
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        var m = el.name.match(/^properties\[(.*)\]$/);
        if (!m) return;
        var val = (el.value || '').trim();
        if (val !== '') properties[m[1]] = val;
      });

      submitEl.disabled = true;
      var origText = submitEl.textContent;
      submitEl.textContent = 'Adding…';

      /* Main product line + any checked upsell add-on (separate cart line). */
      var mainItem = { id: state.current.id, quantity: 1 };
      if (Object.keys(properties).length) mainItem.properties = properties;
      var items = [mainItem];
      var addonEl = formEl.querySelector('[data-vp-upsell-addon]');
      if (addonEl && addonEl.checked) {
        var addonId = parseInt(addonEl.getAttribute('data-vp-upsell-addon'), 10);
        var addonQty = parseInt(addonEl.getAttribute('data-vp-upsell-qty') || '1', 10) || 1;
        if (addonId) {
          var upItem = { id: addonId, quantity: addonQty };
          /* Attach add-on free-text fields (e.g. name tape text) as properties on the add-on line. */
          var upBlk = addonEl.closest('[data-vp-upsell-block]');
          if (upBlk) {
            var upProps = {};
            upBlk.querySelectorAll('[data-vp-upsell-prop]').forEach(function (f) {
              var pn = f.getAttribute('data-vp-upsell-prop');
              if (pn && (f.value || '').trim()) upProps[pn] = f.value.trim();
            });
            if (Object.keys(upProps).length) upItem.properties = upProps;
          }
          items.push(upItem);
        }
      }
      /* Personalization add-on: when "Yes" is chosen, add the configured add-on
         product (personalization fee) as its own line — mirrors the PDP. */
      var persBlock = formEl.querySelector('[data-vp-personalize]');
      if (persBlock) {
        var persInput = persBlock.querySelector('[data-vp-mf-input="leash_personalized"]');
        var persAddonId = parseInt(persBlock.getAttribute('data-vp-personalize-addon'), 10);
        if (persInput && persAddonId && /yes/i.test(persInput.value || '')) {
          items.push({ id: persAddonId, quantity: 1 });
        }
      }
      /* Control Handle add-on: when the custom.control_handle option is "Yes". */
      var chId = parseInt(controlHandleAddonCache[state.product && state.product.handle] || '', 10);
      if (chId) {
        var chActive = formEl.querySelector('.vp-pill.is-active[data-vp-mf-btn="control_handle"]');
        var chInputEl = formEl.querySelector('[data-vp-mf-input="control_handle"]');
        var chVal = chActive ? chActive.getAttribute('data-value') : (chInputEl ? chInputEl.value : '');
        if (/yes/i.test(chVal || '')) items.push({ id: chId, quantity: 1 });
      }
      /* Match each add-on's quantity to the main product quantity (× its base qty). */
      var qaMainQty = parseInt(mainItem.quantity, 10) || 1;
      for (var qi = 1; qi < items.length; qi++) {
        items[qi].quantity = (parseInt(items[qi].quantity, 10) || 1) * qaMainQty;
      }
      /* Bundle-tag main + add-ons so the cart removes them together and locks the add-ons. */
      if (items.length > 1) {
        var bundleId = 'vb-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1e6).toString(36);
        items[0].properties = items[0].properties || {};
        items[0].properties._bundle = bundleId;
        for (var bi = 1; bi < items.length; bi++) {
          items[bi].properties = items[bi].properties || {};
          items[bi].properties._bundle = bundleId;
          items[bi].properties._bundle_addon = 'true';
        }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (out) {
          if (!out.ok) {
            submitEl.textContent = origText;
            submitEl.disabled = false;
            setError((out.data && (out.data.description || out.data.message)) || 'Could not add to cart');
            return;
          }
          submitEl.textContent = 'Added ✓';
          setSuccess('Added to cart.');
          window.refreshValorCartDrawer({ product: out.data });
          /* Close the popup shortly after so user sees the drawer slide in. */
          setTimeout(close, 600);
        })
        .catch(function () {
          submitEl.textContent = origText;
          submitEl.disabled = false;
          setError('Network error. Try again.');
        });
    });

    /* Clear the invalid flag as soon as the user interacts with the field
       (mirrors the PDP). Also clears the generic form error once addressed. */
    function clearInvalidOn(e) {
      var w = e.target.closest && e.target.closest('.vp-invalid');
      if (w) { w.classList.remove('vp-invalid'); setError(''); }
    }
    formEl.addEventListener('change', clearInvalidOn);
    formEl.addEventListener('input', clearInvalidOn);

    /* Delegated click on any Quick Add button */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button.product-quick-add[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-quick-add');
      if (!handle) return;
      open();
      titleEl.textContent = 'Loading…';
      priceEl.textContent = ''; compareEl.textContent = '';
      optionsEl.innerHTML = '';
      if (mfEl) mfEl.innerHTML = '';
      injectText(null);
      submitEl.disabled = true;
      submitEl.textContent = 'Add to Cart';

      if (cache[handle]) { renderProduct(cache[handle]); return; }
      fetch('/products/' + handle + '.js')
        .then(function (res) { return res.json(); })
        .then(function (product) {
          cache[handle] = product;
          renderProduct(product);
        })
        .catch(function () {
          setError('Could not load product.');
          submitEl.disabled = true;
          submitEl.textContent = 'Unavailable';
        });
    });
  });
})();
